import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge, Button, ButtonList, Column, DropdownButton, FlexBox, Page, SearchInput, Spinner, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useToggle } from 'react-use';
import { analytics } from 'app/utils/segment';
import { useBreakpointValue } from 'utils/mediaQuery';
import styles from './teamHeader.module.scss';
const filterToLabels = {
    all: 'All agents',
    online: 'Online only',
    away: 'Away only',
    offline: 'Offline only',
    favourite: 'Favorites only',
};
export const TeamHeader = ({ filter, isAssignedOnly, itemsAsyncStatus, searchTerm, total, onAssignedOnlyClicked, onSearchClose, onFilterClick, onSearch, }) => {
    var _a;
    const isSmallScreen = useBreakpointValue({ base: true, sm: false });
    const [isSearchOpen, toggleSearchOpen] = useToggle(false);
    const handleSearchSubmit = (value) => {
        onSearch({ team_search: value });
    };
    const handleSearchToggle = (isOpen) => {
        toggleSearchOpen(isOpen);
        if (!isOpen && searchTerm) {
            onSearchClose();
        }
    };
    const controls = (_jsxs("div", Object.assign({ className: classnames(styles.controls, {
            [styles.controlsWithSearchOpen]: isSearchOpen,
        }) }, { children: [_jsx(SearchInput, { initialSearch: searchTerm, onSubmit: handleSearchSubmit, onToggle: handleSearchToggle }), _jsx(Button, Object.assign({ variant: isAssignedOnly ? 'primary' : 'secondary', onClick: onAssignedOnlyClicked }, { children: "Assigned agents only" })), _jsx(DropdownButton, Object.assign({ buttonProps: { variant: 'tertiary' }, onToggle: (isOpen) => isOpen && analytics.teamAgentActionsMenuOpened(), dropdown: _jsx(ButtonList, { children: Object.keys(filterToLabels).map((key) => (_jsx(ButtonList.Item, Object.assign({ isSelected: filter === key, onClick: () => onFilterClick(key) }, { children: filterToLabels[key] }), key))) }) }, { children: filterToLabels[filter] }))] })));
    return (_jsxs(_Fragment, { children: [_jsx(Page.Head, { title: _jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center" }, { children: ["Team", _jsx(Badge, Object.assign({ variant: "secondary", size: "medium" }, { children: itemsAsyncStatus === 'loading' ? (_jsx(Spinner, { size: 16 })) : (_jsx("span", { children: (_a = total === null || total === void 0 ? void 0 : total.toString()) !== null && _a !== void 0 ? _a : '0' })) }))] })), controls: !isSmallScreen && controls }), isSmallScreen && (_jsx(Column.Row, Object.assign({ noMinHeight: true, borderBottom: true }, { children: controls })))] }));
};
